import css from './index.module.scss';
import A from './components/A';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import Tab from './components/Tab';

export const en_page = ['us', 'ca', 'uk', 'au', 'za', 'eu'];

export default function Rule() {
    return (
        <div className={css.page}>
            <A />
            <Tab />
            <B />
            <C />
            <D />
            <E />
            <F />
        </div>
    );
}
